<template>
  <PageTemplate alternative>
    <Header mod="care" />
    <Banner mod="care" />
    <Videos mod="care" color="#188a75" />
    <Structure mod="care" />
    <Services mod="care" color="#188a75" />
    <Team mod="care" />
    <Footer mod="care" />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Header from "../../shell/PagesHeader.vue";
import Banner from "../../templates/Banner.vue";
import Videos from "../../templates/Videos.vue";
import Structure from "../../templates/Structure.vue";
import Services from "../../templates/Services.vue";
import Team from "../../templates/Team.vue";
import Footer from "../../shell/PagesFooter.vue";

export default {
  components: {
    PageTemplate,
    Header,
    Banner,
    Videos,
    Structure,
    Services,
    Team,
    Footer,
  },
};
</script>
